import api from '@/api/axiosConfig.js';

const BASE = '/api/geografia';
const unwrap = (response) => response?.data?.data ?? response?.data ?? null;

export const getGeografiaError = (error, fallback = 'No se pudo completar la operación') =>
  error?.response?.data?.message || error?.response?.data?.error || error?.message || fallback;

export async function listProvincias(params = {}) {
  return unwrap(await api.get(`${BASE}/provincias`, { params }));
}

export async function createProvincia(payload) { return unwrap(await api.post(`${BASE}/provincias`, payload)); }
export async function updateProvincia(id, payload) { return unwrap(await api.put(`${BASE}/provincias/${id}`, payload)); }
export async function deactivateProvincia(id) { return unwrap(await api.delete(`${BASE}/provincias/${id}`)); }

export async function listLocalidades(params = {}) {
  return unwrap(await api.get(`${BASE}/localidades`, { params }));
}

export async function createLocalidad(payload) {
  return unwrap(await api.post(`${BASE}/localidades`, payload));
}

export async function updateLocalidad(id, payload) {
  return unwrap(await api.put(`${BASE}/localidades/${id}`, payload));
}

export async function deactivateLocalidad(id) {
  return unwrap(await api.delete(`${BASE}/localidades/${id}`));
}

export async function updateEstadoLocalidades(ids, activo) { return unwrap(await api.patch(`${BASE}/localidades/estado-masivo`, { ids, activo })); }
export async function listPaises(params = {}) { return unwrap(await api.get(`${BASE}/paises`, { params })); }
export async function createPais(payload) { return unwrap(await api.post(`${BASE}/paises`, payload)); }
export async function updatePais(id, payload) { return unwrap(await api.put(`${BASE}/paises/${id}`, payload)); }
export async function deactivatePais(id) { return unwrap(await api.delete(`${BASE}/paises/${id}`)); }
